webpackJsonp([169858455373905],{

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionMeetOutTeam = __webpack_require__(327);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionMeetOutTeam).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _testimonial = __webpack_require__(57);
	
	var _testimonial2 = _interopRequireDefault(_testimonial);
	
	__webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionMeetOutTeam = function SectionMeetOutTeam(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    { gray: gray, title: 'Meet our team' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw800 center' },
	      _react2.default.createElement(_testimonial2.default, {
	        avatarSrc: data.Matti.sizes,
	        name: 'Matti Ketolainen',
	        status: _react2.default.createElement(
	          'span',
	          null,
	          'Head of Partnerships ',
	          _react2.default.createElement('br', null),
	          ' Next Miss'
	        ),
	        comment: '\u201CMy focus is always to deliver great results for our clients. For me, the best part about working with Next Miss is to cooperate with such exceptionally talented teams from all over the world.\u201D'
	      }),
	      _react2.default.createElement(_testimonial2.default, {
	        avatarSrc: data.Kaius.sizes,
	        name: 'Kaius Meskanen',
	        status: _react2.default.createElement(
	          'span',
	          null,
	          'Board Member ',
	          _react2.default.createElement('br', null),
	          ' Next Miss'
	        ),
	        comment: '\u201CI believe in partnerships with great people and powerful execution of state-of-the-art Next Miss service. Delivering great results for our clients is always my first priority.\u201D'
	      }),
	      _react2.default.createElement(_testimonial2.default, {
	        avatarSrc: data.Christina.sizes,
	        name: 'Christina Joyce',
	        status: _react2.default.createElement(
	          'span',
	          null,
	          'Head of Americas ',
	          _react2.default.createElement('br', null),
	          ' Next Miss'
	        ),
	        comment: '\u201CI\u2019m proud to offer the Next Miss platform for a growing number of satisfied local, state and national clients. I personally want to help transform beauty pageants into life-changing events for young women to foster self-confidence, self-expression and community-building. NextMiss allows our customers to access world-class digital tools with little to no upfront costs.\u201D'
	      }),
	      _react2.default.createElement(_testimonial2.default, {
	        avatarSrc: data.Visa.sizes,
	        name: 'Visa Pekkinen',
	        status: _react2.default.createElement(
	          'span',
	          null,
	          'Voting Director  ',
	          _react2.default.createElement('br', null),
	          ' Next Miss'
	        ),
	        comment: '\u201CI have helped our clients to reach +1mil votes in total. I make sure every client gets state-of-the-art casting, voting, judge rating and content in general live in real time situations, regardless of location and time zone.\u201D'
	      })
	    )
	  );
	};
	
	exports.default = SectionMeetOutTeam;
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionWhoWeAre = __webpack_require__(339);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionWhoWeAre).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _mainSectionLayout = __webpack_require__(29);
	
	var _mainSectionLayout2 = _interopRequireDefault(_mainSectionLayout);
	
	var _getStartedButton = __webpack_require__(56);
	
	var _getStartedButton2 = _interopRequireDefault(_getStartedButton);
	
	var _pageTopBar = __webpack_require__(30);
	
	var _pageTopBar2 = _interopRequireDefault(_pageTopBar);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	__webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionWhoWeAre = function SectionWhoWeAre(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _pageTopBar2.default,
	    { iconName: 'masks', text: 'Who we are' },
	    _react2.default.createElement(
	      _mainSectionLayout2.default,
	      {
	        noLogo: true,
	        title: 'Who we are',
	        about: 'We are a team of experts in digital turnkey solutions for beauty pageants'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'mw540 center mb6 bg-logo' },
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'Next Miss is the recognised leader in enabling beauty pageants to reach their next level. Our talented people operate with high energy to unleash our collective entrepreneurial potential to deliver great things for our clients.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'We have great clients who largely come to us via referral, making our reputation our most valuable asset. We take pride in what we do and over the past years have been honoured to be part of some amazing success cases, contributing to the success of our clients and our own growing Next Miss team.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mb7' },
	        _react2.default.createElement(_getStartedButton2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex flex-wrap' },
	        _react2.default.createElement(
	          Block,
	          { title: 'Our vision', bgImage: data.ourValuesBg.sizes },
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'To be leading partner in shaping the future of beauty pageant industry.'
	          ),
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'To be known as a brilliant place to work.'
	          ),
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'To be a thriving business that promotes innovation and entrepreneurship.'
	          )
	        ),
	        _react2.default.createElement(
	          Block,
	          { title: 'Our values', bgImage: data.ourVisionBg.sizes },
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'Next Miss people are Awesome Together.'
	          ),
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'We work with High Energy and Absolute Integrity.'
	          ),
	          _react2.default.createElement(
	            _largeText2.default,
	            { mb4: true },
	            'We Celebrate Simplicity and have a Relentless Commitment to get the right results for our clients, and each other.'
	          )
	        )
	      )
	    )
	  );
	};
	
	function Block(_ref2) {
	  var title = _ref2.title,
	      children = _ref2.children,
	      bgImage = _ref2.bgImage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100 w-50-m ph2 mb3 mb0-m who-we-are-block' },
	    _react2.default.createElement(
	      'div',
	      { className: 'br3 white ph3 pv4 pa5-l h-100 relative' },
	      _react2.default.createElement(
	        'div',
	        { className: 'z-1 absolute absolute--fill' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: bgImage, alt: '', className: 'h-100 w-100 br3' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'relative z-2' },
	        _react2.default.createElement(
	          'h6',
	          { className: 'f6 mt0 mb4 tc' },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          children
	        )
	      )
	    )
	  );
	}
	
	exports.default = SectionWhoWeAre;
	module.exports = exports['default'];

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _testimonial = __webpack_require__(58);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_testimonial).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	var _common = __webpack_require__(31);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Testimonial(_ref) {
	  var avatarSrc = _ref.avatarSrc,
	      name = _ref.name,
	      status = _ref.status,
	      comment = _ref.comment;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex flex-wrap items-center mb5 last-child-mb0' },
	    _react2.default.createElement(
	      'div',
	      { className: 'f11 lh-copy pr0 pr4-l mb3 mb0-l w-100 w-25-l tc tl-l' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: avatarSrc, alt: '', className: 'w60 h60 mb2 dib' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'fw7' },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        status
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'w-100 w-75-l' },
	      _react2.default.createElement(
	        _largeText2.default,
	        { align: _common.isDesktop ? 'left' : 'center' },
	        comment
	      )
	    )
	  );
	}
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/who_we_are.7655f714.png";

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sectionWhoWeAre = __webpack_require__(338);
	
	var _sectionWhoWeAre2 = _interopRequireDefault(_sectionWhoWeAre);
	
	var _sectionMeetOutTeam = __webpack_require__(326);
	
	var _sectionMeetOutTeam2 = _interopRequireDefault(_sectionMeetOutTeam);
	
	var _who_we_are = __webpack_require__(661);
	
	var _who_we_are2 = _interopRequireDefault(_who_we_are);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhoWeAre = function (_Component) {
	  _inherits(WhoWeAre, _Component);
	
	  function WhoWeAre() {
	    _classCallCheck(this, WhoWeAre);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  WhoWeAre.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Who we are'
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Who we are' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We are a team of experts in digital turnkey solutions for beauty pageants' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://nextmiss.com' + _who_we_are2.default }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://nextmiss.com/who_we_are/' }),
	        _react2.default.createElement('meta', { property: 'og:image:alt', content: 'Who we are - Next Miss' })
	      ),
	      _react2.default.createElement(_sectionWhoWeAre2.default, { data: data }),
	      _react2.default.createElement(_sectionMeetOutTeam2.default, { data: data })
	    );
	  };
	
	  return WhoWeAre;
	}(_react.Component);
	
	exports.default = WhoWeAre;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-who-we-are-js-914621cd95b7f343fe59.js